import { Link, withRouter } from 'react-router-dom';

import PropTypes from 'prop-types';
import React from 'react';
import { formatDate } from '../../../../utils/dateUtils';

// COMPONENT
const MonitoredDocumentChangesListItem = ({
    id,
    name,
    lastS3Version,
    s3Version,
    updated,
    created,
    lastChecked,
    match,
}) => (
    <Link
        to={{
            pathname: `/monitored-document/${id}/compare/${lastS3Version},${s3Version}`,
            state: {
                backLink: match.url,
            },
        }}
        className="list-group-item-action"
    >
        <div className="container">
            <div className="row">
                <div className="col-sm">
                    <strong>{name}</strong>
                </div>
                <div className="col-sm">
                    {lastChecked
                        ? formatDate(lastChecked)
                        : updated
                          ? formatDate(updated)
                          : formatDate(created)}
                </div>
            </div>
        </div>
    </Link>
);

MonitoredDocumentChangesListItem.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    s3Version: PropTypes.string.isRequired,
    lastS3Version: PropTypes.string.isRequired,
    isActive: PropTypes.bool,
    created: PropTypes.number.isRequired,
    updated: PropTypes.number,
    lastChecked: PropTypes.number,
    match: PropTypes.object,
};

export default withRouter(MonitoredDocumentChangesListItem);
